import { Component, Input } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { openDocumentInTab } from '../../../shared/file.utils';
import { DocumentModel } from '../../../core/modules/documents/documents.types';
import { DocumentsApiService } from '../../../core/modules/documents/documents-api.service';

@UntilDestroy()
@Component({
  selector: 'tax-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.sass'],
  standalone: true,
  imports: [
    DatePipe,
    NgIf,
  ],
})

export class DocumentComponent {
  @Input() document?: DocumentModel;

  constructor(private documentsApiService: DocumentsApiService) {}

  openDocument(document: DocumentModel): void {
    if (document.mimeType === 'xml') {
      this.documentsApiService.downloadXmlDocument(document.link)
        .pipe(untilDestroyed(this))
        .subscribe((xmlFile) => {
          openDocumentInTab(xmlFile);
        });
    } else {
      window.open(document.link, '_blank');
    }
  }
}
